import { Text, Divider } from 'wix-ui-tpa/cssVars';
import React from 'react';
import type { ItemVariant } from 'root/apiTypes';
import { useVariantLogic } from './Variant.logic';
import { classes } from './Variant.st.css';
import { dataHooks } from 'root/dataHooks';
import { Dots } from 'root/components/Menus/Dots/Dots';

export const Variant = ({ variant, showDivider }: { variant: ItemVariant; showDivider: boolean }) => {
  const { formattedPrice, shouldShowVariantsPrice, variantTitleHtmlTag, variantPriceHtmlTag } = useVariantLogic({
    variant,
  });

  return (
    <div className={classes.variantContainer} data-hook={dataHooks.item.variant} role="listitem">
      <div className={classes.variantDetails}>
        <Text className={classes.variantName} data-hook={dataHooks.variant.name} tagName={variantTitleHtmlTag}>
          {variant.name}
        </Text>
        <Dots variantState />
        {shouldShowVariantsPrice && (
          <Text className={classes.variantPrice} data-hook={dataHooks.variant.price} tagName={variantPriceHtmlTag}>
            {formattedPrice}
          </Text>
        )}
      </div>
      {showDivider && <Divider className={classes.divider} direction="vertical" />}
    </div>
  );
};
